import { render, staticRenderFns } from "./podatek-od-zyskow-z-gield-zagranicznych.md?vue&type=template&id=3374b2a6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports